"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const getOffDays_1 = __importDefault(require("../../utils/branch/getOffDays"));
const getOnDays_1 = __importDefault(require("../../utils/branch/getOnDays"));
const getTimingSummary_1 = __importDefault(require("../../utils/branch/getTimingSummary"));
const getFaqs_1 = __importDefault(require("../../utils/cms/getFaqs"));
/**
 * Returns formatted City Branch info
 * @param {object} city
 * @returns {AirportFactoryType}
 */
function cityBranchFactory(cityBranch) {
    const cityBranchTimings = (0, get_1.default)(cityBranch, 'timings', []);
    return {
        branchId: (0, get_1.default)(cityBranch, 'lumiId', ''),
        name: (0, get_1.default)(cityBranch, 'name', ''),
        slug: (0, get_1.default)(cityBranch, 'slug', ''),
        cityName: (0, get_1.default)(cityBranch, 'city', ''),
        directions: (0, get_1.default)(cityBranch, 'directions', ''),
        phoneNumber: (0, get_1.default)(cityBranch, 'phone', ''),
        email: (0, get_1.default)(cityBranch, 'email', ''),
        type: (0, get_1.default)(cityBranch, 'type', ''),
        timingSummary: (0, getTimingSummary_1.default)(cityBranchTimings),
        offDays: (0, getOffDays_1.default)(cityBranchTimings),
        onDays: (0, getOnDays_1.default)(cityBranchTimings),
        branchDescription: {
            title: (0, get_1.default)(cityBranch, 'branchDescription.title', ''),
            description: (0, get_1.default)(cityBranch, 'branchDescription.description', ''),
        },
        faqs: (0, getFaqs_1.default)((0, get_1.default)(cityBranch, 'faqs', [])),
        metaTitle: (0, get_1.default)(cityBranch, 'metatitle', ''),
        metaDescription: (0, get_1.default)(cityBranch, 'metadescription', ''),
        pageHeading: (0, get_1.default)(cityBranch, 'pageheading', ''),
        pageSubheading: (0, get_1.default)(cityBranch, 'pagesubheading', ''),
        tables: (0, get_1.default)(cityBranch, 'tables', []),
    };
}
exports.default = cityBranchFactory;
